export const Hourglass = ({ isFilled }: { isFilled?: boolean }) => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill={isFilled ? 'black' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.455418 0.25H15.5091L7.79782 10.853L7.69088 11L7.79782 11.147L15.5091 21.75H0.455418L7.21092 11.1342L7.29633 11L7.21092 10.8658L0.455418 0.25Z"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  );
};
